export enum TokenIds {
	RTC = 'rtc',
	RTM = 'rtm',
}
